import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';
import { colors, typography } from '../../styles';

const styles = css`
  .DetailDescription_wrapper {
    font-family: ${typography.Serif};
    margin-top: -5px;
    background-size: cover;
    background-position: center center;
    background-image: url('/images/comm-detail-description-bg-fpo.jpg');
    padding: 30px 30px;
    position: relative;
    z-index: 0;
    @media (min-width: 992px) {
      padding: 90px 60px;
    }
    &:before {
      content: '';
      background-color: rgba(63,63,63, .5);
      position: absolute;
      display: block;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
    }
    &:after {
      content: '';
      background-color: rgba(53,53,53, .9);
      position: absolute;
      display: block;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      @media (min-width: 1200px) {
        right: 25%;
      }
    }
  }
  .DetailDescription {

  }
  .DetailDescription_inner {
    z-index: 3;
    position: relative;
  }
  .DetailDescription_preTitle {
    font-weight: 200;
    font-size: 20px;
    color: #FFFFFF;
    @media (min-width: 992px) {
      font-size: 80px;
    }
  }
  .DetailDescription_title {
    font-weight: 800;
    font-size: 30px;
    line-height: 40px;
    color: ${colors.color3Darker};
    text-transform: uppercase;
    position: relative;
    margin: 0 0 60px 0;
    &:after {
      width: 125px;
      height: 3px;
      position: absolute;
      display: block;
      content: '';
      bottom: -30px;
      background-color: ${colors.color2};
    }
  }
  .DetailDescription_body {
    font-family: ${typography.SanSerif};
    font-weight: 200;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 2.2;
    @media (min-width: 992px) {
      font-size: 18px;
    }
  }
  .DetailDescription_media {
    background-size: cover;
    background-position: center center;
    background-image: url('/images/comm-description-media-fpo.jpg');
  }
`;

function DetailDescription({ community }) {
  return (
    <div className={styles}>
      <div className="DetailDescription" id="description">
        <div className="DetailDescription_wrapper">
          <div className="DetailDescription_inner row">
            <div className="DetailDescription_content col-xl-7">
              <h4 className="DetailDescription_title">
                <span className="DetailDescription_preTitle">Discover</span><br />
                {get(community, 'name')}
              </h4>
              <div className="DetailDescription_body" dangerouslySetInnerHTML={SanitizeHtml(get(community, 'description_override', get(community, 'description')))} />
            </div>
            <div className="DetailDescription_media col-lg-4 ml-auto d-none d-xl-block" style={{ backgroundImage: `url(${buildThumbnailUrl(get(community, 'photos[0].contentUrl', ''), { width: 800, height: 800 })})` }} />
          </div>
        </div>
      </div>
    </div>
  );
}

DetailDescription.propTypes = {
  community: PropTypes.object.isRequired,
};

export default withData(
  {
    community: true,
  },
  {
    required: {
      community: true,
    },
    ifMissing404: true,
  },
)(DetailDescription);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/DetailDescription.js